import { createSlice } from '@reduxjs/toolkit';

const useLocationSlice = createSlice({
  name: 'location',
  initialState: {
    isCondensedView: false
  },
  reducers: {
    setCondensedView: (state, action) => {
        state.isCondensedView = action.payload;
    }
  },
});

export const {
  setCondensedView
} = useLocationSlice.actions;

export default useLocationSlice.reducer;